import React from 'react';
import { Mic2, Scan, BellDot, TrendingUp } from 'lucide-react';

const Benefits = () => {
  // Using your brand colors
  const colors = {
    primary: "#122721",
    background: "#6cf168",
    light: "#f8f9fa"
  };

  const benefits = [
    {
      icon: <Mic2 className="w-8 h-8 md:w-10 md:h-10" color={colors.primary} strokeWidth={1.5} />,
      title: "Voice-to-Invoice",
      description: "Create invoices instantly using just your voice. Speak the details and our AI handles the rest."
    },
    {
      icon: <Scan className="w-8 h-8 md:w-10 md:h-10" color={colors.primary} strokeWidth={1.5} />,
      title: "Smart Document Scanning",
      description: "Scan invoices and receipts with your phone. Our OCR technology extracts all relevant data automatically."
    },
    {
      icon: <BellDot className="w-8 h-8 md:w-10 md:h-10" color={colors.primary} strokeWidth={1.5} />,
      title: "Tax Compliance Alerts",
      description: "Stay compliant with UAE tax regulations. Get timely alerts about new laws and upcoming deadlines."
    },
    {
      icon: <TrendingUp className="w-8 h-8 md:w-10 md:h-10" color={colors.primary} strokeWidth={1.5} />,
      title: "Real-time Financial Insights",
      description: "Monitor your business performance with customizable dashboards and detailed financial reports."
    }
  ];

  return (
    <section id="features" className="py-12 md:py-16" style={{ backgroundColor: colors.light }}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 md:mb-4" style={{ color: colors.primary }}>
            Why Choose Arbaah?
          </h2>
          <p className="text-base md:text-lg mx-auto max-w-3xl px-4" style={{ color: colors.primary }}>
            Our powerful features help UAE businesses streamline their finances and stay compliant
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="bg-white p-5 md:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="mb-3 md:mb-4">
                {benefit.icon}
              </div>
              <h3 className="text-lg md:text-xl font-semibold mb-2" style={{ color: colors.primary }}>
                {benefit.title}
              </h3>
              <p className="text-sm md:text-base" style={{ color: colors.primary }}>
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;